import React, { useCallback } from 'react';
import * as tokenOnchainInfo from '../../../services/onchain-infos.service';

const useTokenOnchainInfo = () => {
  const findToken = useCallback(async (address: string, chainId: number) => {
    try {
      const response = await tokenOnchainInfo.findTokenOnchainInfo(address, chainId);
      const roleData = response.data;
      return roleData;
    } catch (error) {
      console.error('Failed to fetch token metadata:', error);
      throw error;
    }
  }, []);

  return {
    findToken,
  };
};

export default useTokenOnchainInfo;
